import React from 'react';

import { SkeletonBlock, SkeletonOverlay, SKELETON_TOKENS } from 'components/shared';

const SECTION_ROW_COUNTS = [2, 3, 2, 3];
const BOTTOM_ROW_COUNT = 4;

const rowStyle: React.CSSProperties = { display: 'flex', gap: 16, overflow: 'hidden' };
const dividerStyle: React.CSSProperties = { borderTop: `1px solid ${SKELETON_TOKENS.divider}` };

function NavRow() {
    return (
        <div style={rowStyle}>
            <SkeletonBlock height={32} width={40} />
            <SkeletonBlock height={32} style={{ flexShrink: 1, minWidth: 0 }} />
        </div>
    );
}

export default function NavigationSkeleton({ isLoading }: { isLoading: boolean }) {
    return (
        <SkeletonOverlay isLoading={isLoading} style={{ padding: 12, gap: 8 }}>
            <SkeletonBlock height={40} />
            <SkeletonBlock height={40} style={{ marginTop: 8 }} />
            {SECTION_ROW_COUNTS.map((rowCount, section) => (
                <React.Fragment key={section}>
                    <div style={dividerStyle} />
                    {section > 0 && <SkeletonBlock height={16} width={140} />}
                    {Array.from({ length: rowCount }, (_, row) => (
                        <NavRow key={row} />
                    ))}
                </React.Fragment>
            ))}
            <div style={dividerStyle} />
            <div style={{ flexGrow: 1 }} />
            {Array.from({ length: BOTTOM_ROW_COUNT }, (_, row) => (
                <NavRow key={row} />
            ))}
        </SkeletonOverlay>
    );
}
